export const minLength = (min: number = 3) => ({
  min,
  message: (
    <span data-testid="search-term-alert">{`Для поиска введите минимум ${min} символа`}</span>
  ),
});

export const maxLength = (max: number = 300) => ({
  max,
  message: (
    <span data-testid="search-term-alert">
      Превышено максимальное количество символов
    </span>
  ),
});
